import { createListStoreWithQuery } from '@/store/list-state.factory';

export const useDocumentsTableStore = createListStoreWithQuery<{ type: string }>(
  'documents-table-state',
  {
    filterDefaults: {
      type: 'all',
    },
  }
);
